
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Line, mixins } from 'vue-chartjs';

const { reactiveProp } = mixins;

@Component
class LineChart extends Vue.extend({
  mixins: [reactiveProp],
  extends: Line,
  props: {
    chartData: { type: Object, required: true },
    options: { type: Object, required: true },
  },
  mounted() {
    this.renderChart(this.chartData, this.options);
  },
}) {}

@Component({
  components: { LineChart },
})
export default class CpuLineChart extends Vue {
  @Prop({ type: Array, required: true }) readonly points!: Array<{ x: Date; y: number }>;

  get chartData() {
    return {
      datasets: [
        {
          label: 'CPU cores',
          data: this.points,

          borderColor: '#2e7d32',
          borderWidth: 2,
          lineTension: 0.15,

          pointRadius: 0,
          pointHitRadius: 10,
          pointHoverRadius: 4,
          pointHoverBackgroundColor: '#868686',
          pointHoverBorderColor: '#2e7d32',
          pointHoverBorderWidth: 2,

          fill: true,
          backgroundColor: 'rgba(46, 125, 50, 0.12)',
          hoverBorderWidth: 2.5,
        },
      ],
    };
  }

  get options() {
    return {
      responsive: true,
      maintainAspectRatio: false,
      legend: { display: false },

      tooltips: {
        intersect: false,
        mode: 'index',
        callbacks: {
          label: (t: any) => ` ${Number(t.yLabel).toFixed(2)} cores`,
        },
      },
      scales: {
        xAxes: [
          {
            type: 'time',
            time: {
              tooltipFormat: 'YYYY-MM-DD HH:mm',
              displayFormats: {
                hour: 'YYYY-MM-DD HH:mm',
                day: 'YYYY-MM-DD',
              },
            },
            ticks: {
              maxTicksLimit: 8,
              maxRotation: 45,
              minRotation: 45,
            },
            gridLines: {
              display: false,
            },
          },
        ],
        yAxes: [
          {
            ticks: {
              min: 0,
              stepSize: 0.5,
              callback: (v: number) => v.toFixed(1),
            },
            gridLines: {
              color: 'rgba(0, 0, 0, 0.06)',
              drawBorder: false,
            },
          }
        ],
      },
    };
  }
}
